import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, loginRequest } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

export const getAccessToken = async () => {
  const accounts = msalInstance.getAllAccounts();
  if (!accounts || accounts.length === 0) {
    throw new Error('Usuário não autenticado');
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });
    return response.accessToken;
  } catch (error) {
    const response = await msalInstance.acquireTokenPopup(loginRequest);
    return response.accessToken;
  }
};

export default msalInstance;
